// The Comic Machine - Request

var Request = (function() {

  // Configuration settings/properties
  var defaults = {};

  var loading = document.querySelector(".loading");

  // A Request object to be managed by the API
  function Request(options) {

  }

  // Method to make a request
  Request.send = function(options, callback) {

    options = options || {};

    if (!options.url) {
      return callback && callback(false);
    }

    var url = options.url;
    var method = options.method || "GET";
    var type = options.type || "application/json";
    var data = options.data || {};
    var request = new XMLHttpRequest();

    if (type === "application/json" && options.type !== "") {
      data = JSON.stringify(data);
    }

    if (options.loader !== false) {
      var text = "Loading...";
      if (options.loader && options.loader.text) {
        text = options.loader.text;
      }
      loading.querySelector(".loading-heading").innerHTML = text;
      loading.setAttribute("data-active", "true");
    }

    // Open the request to the API server
    request.open(method, options.url);

    // Handle the request state change
    request.onreadystatechange = function() {
      if (request.readyState === XMLHttpRequest.DONE) {
        var data = request.responseText;
        var success = request.status === 200;
        try {
          data = JSON.parse(data);
        } catch (errors) {}
        if (!options.loader || options.loader.close !== false) {
          loading.setAttribute("data-active", "false");
        }
        // Fire the callback
        callback && callback(success, data);
      }
    };

    // Set the correct content type
    if (options.type !== "") {
      request.setRequestHeader("Content-type", type);
    }

    // Set custom headers
    if (options.headers) {
      for (var key in options.headers) {
        request.setRequestHeader(key, options.headers[key]);
      }
    }

    // Make the request
    request.send(data);

  };

  // Public / exposed class
  return Request;

})();
